import wx from "weixin-js-sdk";

export default {
  openLocation(data) {
    wx.ready(function () {
      wx.openLocation({
        latitude: data.latitude, // 纬度，浮点数，范围为90 ~ -90
        longitude: data.longitude, // 经度，浮点数，范围为180 ~ -180。
        name: data.name, // 位置名
        address: data.address, // 地址详情说明
        scale: data.scale, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: data.infoUrl // 在查看位置界面底部显示的超链接,可点击跳转
      });
    });
  }
}